import { gql } from '@apollo/client'

const UPSERT_CHECKLIST_ITEM = gql`
  mutation upsertChecklistItem(
    $itemInfo: ChecklistItemInput!
    $nonprofitOrgId: Int!
  ) {
    upsertChecklistItem(itemInfo: $itemInfo, nonprofitOrgId: $nonprofitOrgId) {
      id
      title
      isCompleted
      updatedAt
      owner {
        id
        firstName
        lastName
      }
      lastUpdatedUser {
        id
        firstName
        lastName
      }
      resourceId
      dueDate
      linkText
      linkUrl
    }
  }
`

export default UPSERT_CHECKLIST_ITEM
